<template>
  <div
    :class="'accordion__title__admin' + openClass"
    @click="toggleCollapse"
    style="cursor: pointer;"
  >
    <label :for="id" @click="toggleCollapse" class="accordion__title__admin-icon">
      <img src="/img/icons/InoRevelar.svg" @click="toggleCollapse" alt />
    </label>
    {{ title }}
    <!-- <div class="t1-checkbox" style="float: right">
      <input type="checkbox" :id="id" v-model="fixes" />
      <label :for="id">
        <span class="check-custom" style="background-color: white !important;"></span>
      </label>
      <button
        v-if="list[id]"
        type="button"
        class="btn btn-edit"
        style="padding: 0px;"
        @click="showTextArea=!showTextArea"
      >
        <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />
      </button>
      <div v-if="showTextArea && fixes" class="form-group">
        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
      </div>
    </div> -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["open", "id", "title"],
  name: "AccordionTitle",
  data() {
    return {
      fixes: false,
      jsonList: {},
      showTextArea: false,
    };
  },
  mounted() {
    this.jsonList = this.list;
  },
  methods: {
    toggleCollapse() {
      this.$emit("toggle");
    },
  },
  watch: {
    fixes(val) {
      this.$set(this.jsonList, this.id, val);
      this.$store.commit("setTitularDocs", this.jsonList);
    },
  },
  computed: {
    ...mapGetters({
      list: "getTitularDocs",
    }),
    openClass() {
      return this.open ? " accordion__title--open" : "";
    },
  },
};
</script>